import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 

// ---------------
 
interface TeamMembersAccessState {
  teamMembers: any[],
  selectedTeamMember: any, 
  isRefreshTeamMembersList: boolean, 
  initialRendering: boolean, 
}

// ---------------

const initialState: TeamMembersAccessState = {
    teamMembers: [], 
    selectedTeamMember: null, 
    isRefreshTeamMembersList: false, 
    initialRendering: true, 
};

// ---------------


export const teamMembersAccessSlice = createSlice({

  name: 'teamMembersAccess',

  initialState,

  reducers: {

    setTeamMembers: (state, action: PayloadAction<any>) => { 

        state.teamMembers = action.payload; 

    },
    setSelectedTeamMember: (state, action: PayloadAction<any>) => { 

      state.selectedTeamMember = action.payload; 

    },
    setIsRefreshTeamMembersList: (state, action: PayloadAction<boolean>) => { 

      state.isRefreshTeamMembersList = action.payload; 

    },
    setInitialRendering: (state, action: PayloadAction<boolean>) => {
  
      state.initialRendering = action.payload; 

    }, 
    resetTeamMembersAccess: (state) => { 
        
      state.teamMembers = []; 
      state.selectedTeamMember = null;
      state.isRefreshTeamMembersList = false;
      state.initialRendering = true; 
    } 

  },

}); 

// ---------------

export const { 
  setTeamMembers, 
  setSelectedTeamMember, 
  setIsRefreshTeamMembersList, 
  setInitialRendering, 
  resetTeamMembersAccess } = teamMembersAccessSlice.actions;

export default teamMembersAccessSlice.reducer;